import React from "react";
import PropTypes from "prop-types";
import { Container } from "@mui/material";

export default function SectionContainer({ children, sx }) {
  return (
    <Container sx={{ maxWidth: 1100, width: "100%", mx: "auto", ...sx }}>
      {children}
    </Container>
  );
}
SectionContainer.propTypes = { children: PropTypes.node, sx: PropTypes.object };
